// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { AcceptRa } from "./accept-ra";

/**
 * One physical interface.
 */
export class NicConfig implements flatbuffers.IUnpackableObject<NicConfigT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NicConfig {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNicConfig(bb: flatbuffers.ByteBuffer, obj?: NicConfig): NicConfig {
    return (obj || new NicConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNicConfig(bb: flatbuffers.ByteBuffer, obj?: NicConfig): NicConfig {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NicConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * netplan netdef id, e.g. "mgmt". Stable across reboots; NOT the kernel name.
   */
  id(): string | null;
  id(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  id(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Matched on MAC where possible — a kernel name can move between boots.
   */
  mac(): string | null;
  mac(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  mac(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Kernel name or glob, when no MAC is known.
   */
  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Rename the matched device to this.
   */
  setName(): string | null;
  setName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  setName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * "standalone" or "bond-member".
   */
  role(): string | null;
  role(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  role(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * "yes" stops boot waiting on an unplugged port.
   */
  optional(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  dhcp4(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  dhcp6(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Router advertisements, held separate to `dhcp6`. RAs alone give an
   * address AND a default route (SLAAC); `DHCPv6` supplies an address out
   * of a server instead.
   */
  acceptRa(): AcceptRa {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : AcceptRa.UNSET;
  }

  /**
   * CIDRs, either family, mixed freely — netplan takes one list for both.
   */
  addresses(index: number): string;
  addresses(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  addresses(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  addressesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  gateway4(): string | null;
  gateway4(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  gateway4(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  gateway6(): string | null;
  gateway6(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  gateway6(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  mtu(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startNicConfig(builder: flatbuffers.Builder) {
    builder.startObject(13);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addMac(builder: flatbuffers.Builder, macOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, macOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, nameOffset, 0);
  }

  static addSetName(builder: flatbuffers.Builder, setNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, setNameOffset, 0);
  }

  static addRole(builder: flatbuffers.Builder, roleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, roleOffset, 0);
  }

  static addOptional(builder: flatbuffers.Builder, optional: boolean) {
    builder.addFieldInt8(5, +optional, +false);
  }

  static addDhcp4(builder: flatbuffers.Builder, dhcp4: boolean) {
    builder.addFieldInt8(6, +dhcp4, +false);
  }

  static addDhcp6(builder: flatbuffers.Builder, dhcp6: boolean) {
    builder.addFieldInt8(7, +dhcp6, +false);
  }

  static addAcceptRa(builder: flatbuffers.Builder, acceptRa: AcceptRa) {
    builder.addFieldInt8(8, acceptRa, AcceptRa.UNSET);
  }

  static addAddresses(builder: flatbuffers.Builder, addressesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, addressesOffset, 0);
  }

  static createAddressesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startAddressesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addGateway4(builder: flatbuffers.Builder, gateway4Offset: flatbuffers.Offset) {
    builder.addFieldOffset(10, gateway4Offset, 0);
  }

  static addGateway6(builder: flatbuffers.Builder, gateway6Offset: flatbuffers.Offset) {
    builder.addFieldOffset(11, gateway6Offset, 0);
  }

  static addMtu(builder: flatbuffers.Builder, mtu: number) {
    builder.addFieldInt32(12, mtu, 0);
  }

  static endNicConfig(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createNicConfig(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    macOffset: flatbuffers.Offset,
    nameOffset: flatbuffers.Offset,
    setNameOffset: flatbuffers.Offset,
    roleOffset: flatbuffers.Offset,
    optional: boolean,
    dhcp4: boolean,
    dhcp6: boolean,
    acceptRa: AcceptRa,
    addressesOffset: flatbuffers.Offset,
    gateway4Offset: flatbuffers.Offset,
    gateway6Offset: flatbuffers.Offset,
    mtu: number,
  ): flatbuffers.Offset {
    NicConfig.startNicConfig(builder);
    NicConfig.addId(builder, idOffset);
    NicConfig.addMac(builder, macOffset);
    NicConfig.addName(builder, nameOffset);
    NicConfig.addSetName(builder, setNameOffset);
    NicConfig.addRole(builder, roleOffset);
    NicConfig.addOptional(builder, optional);
    NicConfig.addDhcp4(builder, dhcp4);
    NicConfig.addDhcp6(builder, dhcp6);
    NicConfig.addAcceptRa(builder, acceptRa);
    NicConfig.addAddresses(builder, addressesOffset);
    NicConfig.addGateway4(builder, gateway4Offset);
    NicConfig.addGateway6(builder, gateway6Offset);
    NicConfig.addMtu(builder, mtu);
    return NicConfig.endNicConfig(builder);
  }

  unpack(): NicConfigT {
    return new NicConfigT(
      this.id(),
      this.mac(),
      this.name(),
      this.setName(),
      this.role(),
      this.optional(),
      this.dhcp4(),
      this.dhcp6(),
      this.acceptRa(),
      this.bb!.createScalarList<string>(this.addresses.bind(this), this.addressesLength()),
      this.gateway4(),
      this.gateway6(),
      this.mtu(),
    );
  }

  unpackTo(_o: NicConfigT): void {
    _o.id = this.id();
    _o.mac = this.mac();
    _o.name = this.name();
    _o.setName = this.setName();
    _o.role = this.role();
    _o.optional = this.optional();
    _o.dhcp4 = this.dhcp4();
    _o.dhcp6 = this.dhcp6();
    _o.acceptRa = this.acceptRa();
    _o.addresses = this.bb!.createScalarList<string>(
      this.addresses.bind(this),
      this.addressesLength(),
    );
    _o.gateway4 = this.gateway4();
    _o.gateway6 = this.gateway6();
    _o.mtu = this.mtu();
  }

  unpackFields(...fields: string[]): NicConfigT {
    const t = new NicConfigT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id();
    }
    if (fieldSet.has("mac")) {
      t.mac = this.mac();
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("set_name")) {
      t.setName = this.setName();
    }
    if (fieldSet.has("role")) {
      t.role = this.role();
    }
    if (fieldSet.has("optional")) {
      t.optional = this.optional();
    }
    if (fieldSet.has("dhcp4")) {
      t.dhcp4 = this.dhcp4();
    }
    if (fieldSet.has("dhcp6")) {
      t.dhcp6 = this.dhcp6();
    }
    if (fieldSet.has("accept_ra")) {
      t.acceptRa = this.acceptRa();
    }
    if (fieldSet.has("addresses")) {
      t.addresses = this.bb!.createScalarList<string>(
        this.addresses.bind(this),
        this.addressesLength(),
      );
    }
    if (fieldSet.has("gateway4")) {
      t.gateway4 = this.gateway4();
    }
    if (fieldSet.has("gateway6")) {
      t.gateway6 = this.gateway6();
    }
    if (fieldSet.has("mtu")) {
      t.mtu = this.mtu();
    }
    return t;
  }
}

export class NicConfigT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: string | Uint8Array | null = null,
    public mac: string | Uint8Array | null = null,
    public name: string | Uint8Array | null = null,
    public setName: string | Uint8Array | null = null,
    public role: string | Uint8Array | null = null,
    public optional: boolean = false,
    public dhcp4: boolean = false,
    public dhcp6: boolean = false,
    public acceptRa: AcceptRa = AcceptRa.UNSET,
    public addresses: string[] = [],
    public gateway4: string | Uint8Array | null = null,
    public gateway6: string | Uint8Array | null = null,
    public mtu: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? builder.createString(this.id!) : 0;
    const mac = this.mac !== null ? builder.createString(this.mac!) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const setName = this.setName !== null ? builder.createString(this.setName!) : 0;
    const role = this.role !== null ? builder.createString(this.role!) : 0;
    const addresses = NicConfig.createAddressesVector(
      builder,
      builder.createObjectOffsetList(this.addresses),
    );
    const gateway4 = this.gateway4 !== null ? builder.createString(this.gateway4!) : 0;
    const gateway6 = this.gateway6 !== null ? builder.createString(this.gateway6!) : 0;

    return NicConfig.createNicConfig(
      builder,
      id,
      mac,
      name,
      setName,
      role,
      this.optional,
      this.dhcp4,
      this.dhcp6,
      this.acceptRa,
      addresses,
      gateway4,
      gateway6,
      this.mtu,
    );
  }

  clone(): NicConfigT {
    const obj = new NicConfigT();
    obj.id = this.id;
    obj.mac = this.mac;
    obj.name = this.name;
    obj.setName = this.setName;
    obj.role = this.role;
    obj.optional = this.optional;
    obj.dhcp4 = this.dhcp4;
    obj.dhcp6 = this.dhcp6;
    obj.acceptRa = this.acceptRa;
    obj.addresses = [...this.addresses];
    obj.gateway4 = this.gateway4;
    obj.gateway6 = this.gateway6;
    obj.mtu = this.mtu;
    return obj;
  }

  equals(other: NicConfigT): boolean {
    if (this.id !== other.id) return false;
    if (this.mac !== other.mac) return false;
    if (this.name !== other.name) return false;
    if (this.setName !== other.setName) return false;
    if (this.role !== other.role) return false;
    if (this.optional !== other.optional) return false;
    if (this.dhcp4 !== other.dhcp4) return false;
    if (this.dhcp6 !== other.dhcp6) return false;
    if (this.acceptRa !== other.acceptRa) return false;
    if (this.addresses.length !== other.addresses.length) return false;
    for (let i = 0; i < this.addresses.length; i++) {
      if (this.addresses[i] !== other.addresses[i]) return false;
    }
    if (this.gateway4 !== other.gateway4) return false;
    if (this.gateway6 !== other.gateway6) return false;
    if (this.mtu !== other.mtu) return false;
    return true;
  }
}

export function verifyNicConfig(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
    verifier.checkScalarField(tablePos, 18, 1);
    verifier.checkScalarField(tablePos, 20, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 28, 4);
  } finally {
    verifier.popDepth();
  }
}
